import { ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import adminTheme from './adminTheme';

interface Props {
  children: ReactNode;
}

/** MUI dashboard template theme — https://mui.com/material-ui/getting-started/templates/dashboard/ */
export default function AdminThemeProvider({ children }: Props) {
  return (
    <ThemeProvider theme={adminTheme} defaultMode="light">
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
